module.exports = __webpack_public_path__ + "static/media/demo_results_3.3b585c7a.png";